import React, { useCallback, useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import { isValidPhoneNumber } from "react-phone-number-input/input";
import PhoneInput from "react-phone-number-input";
import CustomPhoneNumber from "./PhoneNumber";
import "react-phone-number-input/style.css";
import toast, { Toaster } from "react-hot-toast";
import ImageViewer from "react-simple-image-viewer";
import Autocomplete from "../utils/Autocomplete";

import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import OutlinedDiv from "./OutlinedDiv";
import lock from "../assets/lock.png";
import "./index.css";

// import Mockdata from "./mock.json";

const locations = [
  { value: "rooftop", label: "Rooftop" },
  { value: "balcony", label: "Balcony" },
  { value: "windowsill", label: "Windowsill" },
  { value: "indoor", label: "Indoor" },
  { value: "garden", label: "Garden" },
  { value: "other", label: "Other" },
];
const testImages = [
  "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e?w=164&h=164&fit=crop&auto=format",
  "https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=164&h=164&fit=crop&auto=format",
  "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c?w=164&h=164&fit=crop&auto=format",
  "https://images.unsplash.com/photo-1533827432537-70133748f5c8?w=164&h=164&fit=crop&auto=format",
  "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f?w=164&h=164&fit=crop&auto=format",
  "https://images.unsplash.com/photo-1589118949245-7d38baf380d6?w=164&h=164&fit=crop&auto=format",
];
export default () => {
  const [historyData, setHistoryData] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [loadStatus, setLoadStatus] = useState({
    fetchProgress: 0,
    isLoading: false,
    showProgressBars: false,
  });

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (userInfo?.username?.key) {
      fetchHistory(userInfo?.username?.key);
    }
  }, [userInfo]);

  const fetchUserInfo = async () => {
    let gotUserCredits;
    try {
      if (typeof window !== "undefined") {
        const grabUserCredits = await fetch(
          "https://api.hotspotrf.com/v2/api/user",
          { credentials: "include" }
        );
        gotUserCredits = await grabUserCredits.json();
        if (gotUserCredits && gotUserCredits?.username?.user)
          setUserInfo(gotUserCredits);
      }
    } catch (err) {
      console.log("fetchUserInfo Error ::::", err.message);
      toast.error("fetchUserInfo Error: " + err.message);
    }
  };

  const fetchHistory = async (userAPIKey = null) => {
    let response;
    setLoadStatus({
      fetchProgress: 0,
      isLoading: true,
      showProgressBars: true,
    });
    const timer = setTimeout(
      () =>
        setLoadStatus({
          ...loadStatus,
          fetchProgress: loadStatus.fetchProgress + 10,
        }),
      50
    );
    try {
      // extract the data
      response = await fetch(
        `https://host-matching.hotspotrf.com/api/hosthistory?key=${userAPIKey}`
      );

      let data = await response.json();
      if (data.success && data.message) {
        clearTimeout(timer);
        setLoadStatus({
          fetchProgress: 100,
          isLoading: false,
          showProgressBars: false,
        });
        setHistoryData(data.message);
      }

      // setHistoryData(Mockdata);
    } catch (error) {
      // Stop publishing state
      clearTimeout(timer);
      setLoadStatus({
        fetchProgress: 0,
        isLoading: false,
        showProgressBars: false,
      });
      console.log("Getting History Error ::::", error.message);
      toast.error("HistoryData API Request Failed");
    }
  };

  const isEmptyObject = (obj) => {
    if (obj === null || obj === undefined) return true;
    return Object.keys(obj).length === 0;
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleUpdate = async (row) => {
    if (row?.original?.contact_info?.name === "") {
      return toast.error("Name is required.");
    }
    if (!validateEmail(row?.original?.contact_info?.email)) {
      return toast.error("Email is not valid.");
    }
    if (!row?.original?.contact_info?.phone) {
      return toast.error("Phone number is required.");
    }
    if (!isValidPhoneNumber(row?.original?.contact_info?.phone)) {
      return toast.error("Phone number is not valid.");
    }
    if (
      row?.original?.hasOwnProperty("addressUpdated") &&
      !row?.original?.addressUpdated
    ) {
      return toast.error(
        "Address is not valid. Please select address from dropdown search."
      );
    }

    const auto_info = {
      car_make: row?.original?.auto_info?.car_make,
      car_model: row?.original?.auto_info?.car_model,
      car_year: row?.original?.auto_info?.car_year,
      miles_year: row?.original?.auto_info?.miles_year,
      auto_additional_info: row?.original?.auto_info?.auto_additional_info,
    };
    const dewi_info = {
      terrain: row?.original?.dewi_info?.terrain,
      elevation: row?.original?.dewi_info?.elevation,
      building_type: row?.original?.dewi_info?.building_type,
      install_locations: row?.original?.dewi_info?.install_locations,
      rooftop: row?.original?.dewi_info?.rooftop,
      power_ethernet: row?.original?.dewi_info?.power_ethernet,
      download_speed: row?.original?.dewi_info?.download_speed,
      dewi_additional_info: row?.original?.dewi_info?.dewi_additional_info,
    };
    if (row?.original?.dewi_info?.photos) {
      for (var i = 0; i < row?.original?.dewi_info?.photos?.length; i++) {
        if (row?.original?.dewi_info?.photos[i].includes("blob:")) {
          row?.original?.dewi_info?.photos.splice(i, 1);
          i--;
        }
      }
      dewi_info.photos = row?.original?.dewi_info?.photos;
    }

    const payload = {
      contact_info: {
        name: row?.original?.contact_info?.name,
        email: row?.original?.contact_info?.email,
        phone: row?.original?.contact_info?.phone,
        address: row?.original?.contact_info?.address,
        communication_method: row?.original?.contact_info?.communication_method,
      },
      host_interest: {
        helium_mobile: row?.original?.host_interest?.helium_mobile,
        helium_iot: row?.original?.host_interest?.helium_iot,
        pollen_mobile: row?.original?.host_interest?.pollen_mobile,
        dimo: row?.original?.host_interest?.dimo,
        hivemapper: row?.original?.host_interest?.hivemapper,
      },
      host_unlocks: {
        helium_mobile: row?.original?.host_unlocks?.helium_mobile,
        helium_iot: row?.original?.host_unlocks?.helium_iot,
        pollen_mobile: row?.original?.host_unlocks?.pollen_mobile,
        dimo: row?.original?.host_unlocks?.dimo,
        hivemapper: row?.original?.host_unlocks?.hivemapper,
      },
      disclaimer: row?.original?.disclaimer,
      lat: row?.original?.lat,
      lng: row?.original?.lng,
      key: row?.original?.key,
      user: userInfo.username.user,
      submission_time: new Date(),
    };

    if (
      !auto_info.car_make &&
      !auto_info.car_model &&
      !auto_info.car_year &&
      !auto_info.miles_year &&
      !auto_info.auto_additional_info
    )
      payload.auto_info = {};
    else payload.auto_info = auto_info;

    if (
      !dewi_info.terrain &&
      !dewi_info.elevation &&
      !dewi_info.building_type &&
      !dewi_info.install_locations &&
      !dewi_info.rooftop &&
      !dewi_info.power_ethernet &&
      !dewi_info.download_speed &&
      !dewi_info.dewi_additional_info
    )
      payload.dewi_info = {};
    else payload.dewi_info = dewi_info;

    const params = { id: row?.original?._id, host: payload };

    const formData = new FormData();
    for (let i = 0; i < row?.original?.photoFiles?.length; i++) {
      formData.append(`images_` + i, row?.original?.photoFiles[i]);
    }
    formData.append("params", JSON.stringify(params));
    if (row?.original?.deletedPhotos)
      formData.append(
        "deletedPhotos",
        JSON.stringify(row?.original?.deletedPhotos)
      );

    try {
      // // Debug API in vercel
      // await fetch("/api/hosthistory", {
      await fetch("https://host-matching.hotspotrf.com/api/hosthistory", {
        method: "PUT",
        body: formData,
      });

      toast.success("Successfully updated");
    } catch (error) {
      toast.error("Submit Error: " + error.message);
    }
  };

  const handleDelete = async (row) => {
    try {
      const params = { id: row?.original?._id };
      await fetch("https://host-matching.hotspotrf.com/api/hosthistory/", {
        method: "DELETE",
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      toast.success("Successfully deleted");
      historyData.splice(row.index, 1);
      setHistoryData([...historyData]);
    } catch (error) {
      toast.error("Submit Error: " + error.message);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "contact_info.name",
        header: "Name",
        size: 100,
      },
      {
        accessorKey: "contact_info.address",
        header: "Address",
      },
      {
        accessorKey: "host_interest.helium_mobile",
        header: "Helium Mobile",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        size: 70,
      },
      {
        accessorKey: "host_interest.helium_iot",
        header: "Helium IoT",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        size: 60,
      },
      {
        accessorKey: "host_interest.pollen_mobile",
        header: "Pollen Mobile",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        size: 70,
      },
      {
        accessorKey: "host_interest.dimo",
        header: "DIMO",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        size: 40,
      },
      {
        accessorKey: "host_interest.hivemapper",
        header: "Hivemapper",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        size: 60,
      },
    ],
    []
  );

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const deletePhoto = async (rowIndex, photoIndex) => {
    setHistoryData(
      historyData.map((x, index) => {
        if (index === rowIndex) {
          const s = x.dewi_info.photos.filter((item, i) => i !== photoIndex);
          const q = x.dewi_info.photos.filter((item, i) => i === photoIndex);
          x.dewi_info.photos = s;
          if (q.length > 0 && !q[0].includes("blob:")) {
            x.deletedPhotos = x.deletedPhotos
              ? x.deletedPhotos.concat(q[0])
              : [q[0]];
          }
          if (x.photoFiles && x.photoFiles.length > 0) {
            const r = x.phofoFileIndexs.filter(
              (item, i) => item.index !== photoIndex
            );
            const p = Array.from(x.photoFiles).filter(
              (item, i) =>
                item.name !==
                x.phofoFileIndexs.filter(
                  (item, i) => item.index === photoIndex
                )[0].name
            );
            x.phofoFileIndexs = r;
            x.photoFiles = p;
          }
          return x;
        }
        return x;
      })
    );
  };

  const uploadPhoto = async (e, rowIndex) => {
    const files = e.target.files || e.dataTransfer.files;
    const count = historyData[rowIndex].dewi_info.photos.length + files.length;
    if (!files.length) return;
    if (files.length > 6 || count > 6) {
      return toast.error(
        "You are only allowed to upload a maximum of 6 files for the host."
      );
    }
    for (let i = 0; i < files.length; i++) {
      if (!files[i].type.match("image") || files[i].size / 1024 / 1024 > 4)
        return toast.error(
          "You are only allowed to upload up to 4MB per image."
        );
    }

    const selectedFilesArray = Array.from(files);
    const imagesArray = Array.from(selectedFilesArray).map((file) => {
      return URL.createObjectURL(file);
    });

    setHistoryData(
      historyData.map((x, index) => {
        if (index === rowIndex) {
          const selectedFilesArray = Array.from(files);
          if (x.dewi_info.photos) {
            for (let i = 0; i < selectedFilesArray.length; i++) {
              const len = x.dewi_info.photos.length;
              x.phofoFileIndexs = x.phofoFileIndexs
                ? x.phofoFileIndexs.concat({
                    index: len + i,
                    name: selectedFilesArray[i].name,
                  })
                : [
                    {
                      index: len + i,
                      name: selectedFilesArray[i].name,
                    },
                  ];
            }
          }
          x.dewi_info.photos = x.dewi_info.photos.concat(imagesArray);
          x.photoFiles = x.photoFiles
            ? x.photoFiles.concat(selectedFilesArray)
            : [].concat(selectedFilesArray);
          return x;
        }
        return x;
      })
    );
  };

  const handleRefresh = () => {
    fetchHistory(userInfo?.username?.key);
  };

  return (
    <div className="container relative">
      <div className={isEmptyObject(userInfo) ? "hostContainer" : undefined}>
        <MaterialReactTable
          columns={columns}
          data={historyData}
          enableColumnActions={false}
          enableDensityToggle={false}
          enableColumnFilters={false}
          enableHiding={false}
          initialState={{
            density: "compact",
          }}
          muiTablePaginationProps={{
            labelRowsPerPage: "",
          }}
          muiTableProps={{
            sx: {
              tableLayout: "fixed",
            },
          }}
          muiSearchTextFieldProps={{
            placeholder: "Search",
            sx: { minWidth: "18rem" },
          }}
          renderDetailPanel={({ row }) => {
            return (
              <>
                <OutlinedDiv
                  label="Contact Information"
                  className="outlined_div w-100"
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr 2fr",
                      gap: 4,
                      width: "100%",
                    }}
                  >
                    <TextField
                      className="text-input"
                      label="Name"
                      value={row?.original?.contact_info?.name}
                      variant="standard"
                      required
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.contact_info.name = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                    />
                    <TextField
                      className="text-input"
                      label="Email"
                      value={row?.original?.contact_info?.email}
                      variant="standard"
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.contact_info.email = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                    />
                    <PhoneInput
                      className="text-input"
                      international
                      defaultCountry="US"
                      withCountryCallingCode
                      value={row?.original?.contact_info?.phone ?? undefined}
                      autoComplete="off"
                      onChange={(val) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.contact_info.phone = val;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      inputComponent={CustomPhoneNumber}
                    />
                    <TextField
                      select
                      label="Preferred communication"
                      value={row?.original?.contact_info?.communication_method}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.contact_info.communication_method =
                                e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value="sms">SMS</MenuItem>
                      <MenuItem value="call">Call</MenuItem>
                      <MenuItem value="email">Email</MenuItem>
                    </TextField>
                    <Autocomplete
                      isMui={true}
                      defValue={row?.original?.contact_info?.address}
                      onChange={(val) => {
                        if (val && val !== "")
                          setHistoryData(
                            historyData.map((x, index) => {
                              if (index === row.index) {
                                x.addressUpdated = false;
                                return x;
                              }
                              return x;
                            })
                          );
                      }}
                      onSelect={(place) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.contact_info.address = place?.place_name;
                              x.lat = place?.center[1];
                              x.lng = place?.center[0];
                              x.addressUpdated = true;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                    />
                  </Box>
                </OutlinedDiv>
                <OutlinedDiv
                  label="DeWi Install Questionnaire"
                  className="outlined_div w-100"
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: 4,
                      width: "100%",
                    }}
                  >
                    <TextField
                      select
                      label="Helium Mobile"
                      value={row?.original?.host_interest?.helium_mobile ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.host_interest.helium_mobile = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="Helium IoT"
                      value={row?.original?.host_interest?.helium_iot ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.host_interest.helium_iot = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="Pollen Mobile"
                      value={row?.original?.host_interest?.pollen_mobile ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.host_interest.pollen_mobile = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
                      gap: 4,
                      width: "100%",
                      marginTop: 1,
                    }}
                  >
                    <TextField
                      select
                      label="Terrain"
                      value={row?.original?.dewi_info?.terrain ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.terrain = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value="urban">
                        Urban - Tall buildings everywhere
                      </MenuItem>
                      <MenuItem value="mix">
                        Healthy Mix - 3 to 4 story buildings scattered
                        (occasional tree)
                      </MenuItem>
                      <MenuItem value="suburbs">
                        Suburbs - 1/2 story houses everywhere (occasional tree)
                      </MenuItem>
                      <MenuItem value="wooded">
                        Wooded Area - Trees w/ the occasional barn
                      </MenuItem>
                      <MenuItem value="clear">
                        Clear Line of Site - Can see for miles on end
                      </MenuItem>
                    </TextField>

                    <TextField
                      className="text-input"
                      label="Elevation(M)"
                      type="number"
                      inputProps={{
                        step: 0.01,
                      }}
                      value={row?.original?.dewi_info?.elevation ?? 0}
                      variant="standard"
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.elevation = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                    <TextField
                      select
                      label="Building type"
                      value={row?.original?.dewi_info?.building_type ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.building_type = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value="house">House</MenuItem>
                      <MenuItem value="apartment">Apartment</MenuItem>
                      <MenuItem value="high_condo">High-rise/Condo</MenuItem>
                      <MenuItem value="commercial">Commercial</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="Rooftop access"
                      value={row?.original?.dewi_info?.rooftop ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.rooftop = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="Power & Ethernet"
                      value={row?.original?.dewi_info?.power_ethernet ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.power_ethernet = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="100Mbs/10Mbs"
                      value={row?.original?.dewi_info?.download_speed ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.download_speed = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      marginTop: 1,
                    }}
                  >
                    <FormControl sx={{ width: "100%" }} variant="standard">
                      <InputLabel id="demo-multiple-chip-label">
                        Install Locations
                      </InputLabel>
                      <Select
                        multiple
                        value={
                          row?.original?.dewi_info?.install_locations ?? []
                        }
                        onChange={(e) => {
                          setHistoryData(
                            historyData.map((x, index) => {
                              if (index === row.index) {
                                x.dewi_info.install_locations = e.target.value;
                                return x;
                              }
                              return x;
                            })
                          );
                        }}
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip key={value} label={value} />
                            ))}
                          </Box>
                        )}
                      >
                        {locations.map((name) => (
                          <MenuItem key={name.value} value={name.value}>
                            {name.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      className="text-input w-100"
                      sx={{ marginTop: 1 }}
                      label="Additional Info Contains"
                      value={
                        row?.original?.dewi_info?.dewi_additional_info ?? ""
                      }
                      variant="standard"
                      multiline
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.dewi_info.dewi_additional_info = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                  </Box>
                </OutlinedDiv>
                <OutlinedDiv
                  label="Upload Images"
                  className="outlined_div w-100"
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(6, 1fr)",
                      width: "100%",
                      justifyItems: "center",
                    }}
                  >
                    {row?.original?.dewi_info?.photos?.map((image, index) => (
                      <Box className="thumb-container" key={index}>
                        <Box
                          className="cursor-pointer border border-gray-300 rounded-4"
                          component="img"
                          sx={{
                            height: "80px !important",
                            width: "170px !important",
                          }}
                          alt="Upload Photo"
                          src={image}
                          onClick={() => openImageViewer(index)}
                        />
                        <span
                          className="close-button"
                          onClick={() => deletePhoto(row.index, index)}
                        ></span>
                      </Box>
                    ))}
                    {isViewerOpen && (
                      <ImageViewer
                        src={row?.original?.dewi_info?.photos}
                        currentIndex={currentImage}
                        onClose={closeImageViewer}
                        disableScroll={false}
                        backgroundStyle={{
                          backgroundColor: "rgba(0,0,0,0.9)",
                          zIndex: 10000,
                        }}
                        closeOnClickOutside={true}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box className="text-center m-2">
                      Optional: Upload photos of your proposed install location.
                      Top performing locations have high elevation. Applications
                      with photos generally receive better offers.
                    </Box>
                    <Box className="text-center m-2">
                      Note: Maximum of 6 photos per application, 4MB per photo,
                      and only jpeg, jpg, and png are allowed.
                    </Box>
                    <Box
                      style={{
                        display:
                          row?.original?.dewi_info?.photos?.length === 6
                            ? "none"
                            : "block",
                        textAlign: "center",
                      }}
                    >
                      <input
                        onChange={(e) => uploadPhoto(e, row.index)}
                        className="displayNone"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        id="upload"
                        multiple="multiple"
                        hidden
                      />
                      <label className="button button-info" htmlFor="upload">
                        Upload
                      </label>
                    </Box>
                  </Box>
                </OutlinedDiv>
                <OutlinedDiv label="Automotive Questionaire" className="w-100">
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 4,
                      width: "100%",
                    }}
                  >
                    <TextField
                      select
                      label="DIMO"
                      value={row?.original?.host_interest?.dimo ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.host_interest.dimo = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    <TextField
                      select
                      label="Hivemapper"
                      value={row?.original?.host_interest?.hivemapper ?? ""}
                      onChange={(e) => {
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.host_interest.hivemapper = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        );
                      }}
                      variant="standard"
                    >
                      <MenuItem value="" disabled hidden>
                        Select...
                      </MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: 4,
                      width: "100%",
                      marginTop: 1,
                    }}
                  >
                    <TextField
                      className="text-input"
                      label="Car make"
                      value={row?.original?.auto_info?.car_make ?? ""}
                      variant="standard"
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.auto_info.car_make = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                    <TextField
                      className="text-input"
                      label="Car model"
                      value={row?.original?.auto_info?.car_model ?? ""}
                      variant="standard"
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.auto_info.car_model = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                    <TextField
                      className="text-input"
                      label="Car year"
                      type="number"
                      inputProps={{
                        min: 1900,
                        max: 2099,
                        step: 1,
                      }}
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 4);
                      }}
                      value={
                        row?.original?.auto_info?.car_year ??
                        new Date().getFullYear()
                      }
                      variant="standard"
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.auto_info.car_year = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                    <TextField
                      className="text-input"
                      label="Miles/year"
                      type="number"
                      inputProps={{
                        min: 0,
                        max: 100000,
                        step: 1,
                      }}
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 6);
                      }}
                      value={row?.original?.auto_info?.miles_year ?? 0}
                      variant="standard"
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.auto_info.miles_year = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      marginTop: 1,
                    }}
                  >
                    <TextField
                      className="text-input w-100"
                      label="Additional Info Contains"
                      value={
                        row?.original?.auto_info?.auto_additional_info ?? ""
                      }
                      variant="standard"
                      multiline
                      onChange={(e) =>
                        setHistoryData(
                          historyData.map((x, index) => {
                            if (index === row.index) {
                              x.auto_info.auto_additional_info = e.target.value;
                              return x;
                            }
                            return x;
                          })
                        )
                      }
                    />
                  </Box>
                </OutlinedDiv>
                <Box
                  sx={{
                    width: "100%",
                    marginTop: 1,
                    textAlign: "right",
                  }}
                >
                  <button
                    className="button button-info"
                    onClick={() => handleUpdate(row)}
                  >
                    Save Changes
                  </button>
                  <button
                    className="button button-delete"
                    onClick={() => handleDelete(row)}
                  >
                    Delete
                  </button>
                </Box>
              </>
            );
          }}
          renderTopToolbarCustomActions={({ table }) => (
            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <Typography variant="h6">Host Applications</Typography>
              <IconButton onClick={handleRefresh} title="Refresh">
                <RefreshIcon />
              </IconButton>
            </Box>
          )}
          muiLinearProgressProps={({ isTopToolbar }) => ({
            color: "secondary",
            sx: { display: isTopToolbar ? "block" : "none" }, //only show top toolbar progress bar
            value: loadStatus.fetchProgress, //show precise real  progress value if you so desire
            variant: "determinate",
          })}
          state={{
            isLoading: loadStatus.isLoading,
            showProgressBars: loadStatus.showProgressBars,
          }}
        />
      </div>
      {isEmptyObject(userInfo) && (
        <div className="lockContainer">
          <img
            src={lock}
            className="lockImg"
            onClick={() =>
              window.open("https://hotspotrf.com/my-account/", "_self")
            }
          />
          <p
            className="lockDesc"
            onClick={() =>
              window.open("https://hotspotrf.com/my-account/", "_self")
            }
          >
            Please login to view/edit your applications.
          </p>
          <button
            onClick={() =>
              window.open("https://hotspotrf.com/my-account/", "_self")
            }
          >
            Login / Register
          </button>
        </div>
      )}
      <Toaster position="bottom-right" reverseOrder={false} />
    </div>
  );
};
